
riot.tag2('export-persons-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Экспорт</div>\n    </yield>\n    <yield to="body">\n      <loader text="Экспорт" indeterminate="true" if="{loader}"></loader>\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="row">\n          <div class="col-md-6 col-xs-12">\n            <div class="form-group">\n              <label class="control-label">От даты</label>\n              <datetime-picker class="form-control date-picker" name="dateFrom" data-sign="&gt;=" format="YYYY-MM-DD" value="{item.dateFrom}"></datetime-picker>\n            </div>\n          </div>\n          <div class="col-md-6 col-xs-12">\n            <div class="form-group">\n              <label class="control-label">До даты</label>\n              <datetime-picker class="form-control date-picker" name="dateTo" data-sign="&gt;=" format="YYYY-MM-DD" value="{item.dateTo}"></datetime-picker>\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button" __disabled="{cannotBeClosed}">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" id="startImp" onclick="{parent.submit}" type="button" __disabled="{cannotBeClosed}">Экспорт</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;
self.loader = true;

self.on('mount', function () {
    var modal = self.tags['bs-modal'];

    modal.error = false;
    modal.mixin('validation');
    modal.mixin('change');

    modal.item = {
        dateFrom: '',
        dateTo: ''
    };

    modal.loader = false;

    modal.clear = function () {
        modal.item.dateFrom = '';
        modal.item.dateTo = '';
    };
});

self.submit = function () {
    var modal = self.tags['bs-modal'];
    modal.loader = true;

    API.request({
        object: 'Contact',
        method: 'Export',
        data: modal.item,
        success: function success(response) {
            var a = document.createElement('a');
            a.href = response.url;
            a.download = response.name;
            document.body.appendChild(a);
            a.click();
            a.remove();
            modal.modalHide();
        }
    });
};
});


// WEBPACK FOOTER //
// ./modals/export-persons-modal.tag